module.exports = __webpack_public_path__ + "img/jp.f46d0de3.svg";